import { t } from '@lingui/core/macro';
import { getOrderedRecipientsArray } from 'app/domains/esigning/utils';
import { PendingRecipient } from './PendingRecipient';
import { RecipientsAccordion } from '../../../RecipientsAccordion';
export function OrderedSignerRecipients(props) {
    const { recipients } = props;
    if (!recipients.length) {
        return null;
    }
    const getOrderedLabel = (order) => {
        const orderNumber = order + 1;
        return t({
            message: `Signing order ${orderNumber}`,
            comment: 'Label for signing parties with order selected',
        });
    };
    const orderEntries = getOrderedRecipientsArray(recipients);
    return orderEntries.map(([order, orderedRecipients]) => (<RecipientsAccordion hideTooManyItems key={order} title={getOrderedLabel(+order)}>
      {orderedRecipients.map((recipient) => (<PendingRecipient key={recipient.id} recipient={recipient} isOnlyRecipient={recipients.length === 1}/>))}
    </RecipientsAccordion>));
}
